// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3HhWp","content":"styles_content__3YtCc","checkbox":"styles_checkbox__1-G98","checkboxLabel":"styles_checkboxLabel__2-bzZ"};